import React from 'react';
import HeaderGroup from '~/common/components/HeaderGroup';
import Button from '~/common/components/CommonButton';

import styles from './trial-info.css';

const TrialInfoBlock = ({ switchTotrial }) => (
    <div className={styles.wrapper}>
        <HeaderGroup modifiers={styles['header-grp']}>
            <h2 className={styles.header}>
                Not sure which plan is right for you?
            </h2>
            <h3 className={styles['sub-header']}>
                Try Grasshopper free for 7 days. No credit card required.
            </h3>
        </HeaderGroup>
        {
            <Button
                alternateColor
                arrow
                modifier={styles['trial-cta']}
                onClick={switchTotrial}
            >Start a Free Trial</Button>
        }
    </div>
);

export default TrialInfoBlock;
